<template>
	<TreeSelect v-model="value"
				:label-text="labelText"
				:selected-values-text-multiple="$t('common.select.industry.multiple')"
				:api="getIndustryTreeList"
				options-value-field="data.naceCode"
				:options-display-getter="formatIndustryOption"
				:search-allow="true"
				:search-debounce="500"
				content-size="auto"
				auto-max-height="75%"
				:disabled="disabled"
				:required="required"
				:error="error"
				ref="select"
	></TreeSelect>
</template>
<script>
import {commonApi} from "@/common/api/commonApi";
import TreeSelect from "@/components/templates/common/TreeSelect.vue";
import {formatAsIndustryText} from "@/common/format";

export default {
	components: { TreeSelect },
	props: {
		value: { type: Array, default: [] },
		labelText: { type: String },
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false },
		error: { type: Boolean, default: "" },
	},
	methods: {
		getIndustryTreeList() {
			return commonApi.getIndustryTreeList();
		},
		resetSearch() {
			this.$refs.select.resetSearch();
		},
		formatIndustryOption(option) {
			return formatAsIndustryText(option.data.naceCode);
		}
	},
	watch: {
		value() {
			this.$emit("input", this.value);
		}
	}
};
</script>
